// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
import {initFormHandler} from "./FormHandler";

require('./../Sass/base.scss');
import * as helper from "./../../../../../VX/View/Assets/Js/helper";
import {initImprint} from "../../../../../DynBanner/View/Assets/JS/imprint_la";

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
}

helper.onDocumentLoaded(() => {
	const imprintLink = document.getElementById('variant-f-imprintlink') as Element;
	const privacyLink = document.getElementById('variant-f-privacylink') as Element;
	initImprint(imprintLink, privacyLink);

	const girlHolder = document.getElementById('girlHolder');
	const ab1 = parseInt(helper.getData(girlHolder, 'ab1'));
	const targetUrl = helper.getData(girlHolder, 'target');
	const failUrl = helper.getData(girlHolder, 'fail');
	const ws = helper.getData(girlHolder, 'ws');
	
	const girls = Array.from(document.querySelectorAll('.girlcontainer'));
	let clickCounter = 0;
	let liked = [];

	const likes = document.querySelectorAll('.like');
	const dislikes = document.querySelectorAll('.unlike');
	const hearts = document.querySelectorAll('.heart');
	const modal = document.getElementById('modal-f') as Element;

	const form = document.getElementById('form') as HTMLFormElement;
	form.addEventListener('submit', (e) => {
		e.preventDefault();
	});

	const createMatchScreen = () => {
		let girl = girls.pop();

		if (liked.length !== 0) {
			girl = liked[Math.floor(Math.random() * liked.length)];
		}

		const name = girl.querySelector('.model-avatar').getAttribute('alt');
		const imageSrc = girl.querySelector('.model-avatar').getAttribute('src');
		const text = document.getElementById('p-modal-description') as HTMLParagraphElement;
		const image = document.getElementById('modal-avatar') as HTMLImageElement;

		text.innerText = text.innerText.replace('{{SOMEONE}}', name);
		image.setAttribute('src', imageSrc);
		image.setAttribute('alt', name);

		initFormHandler(targetUrl, failUrl, helper.getData(girl, 'id'), ws);
	}

	likes.forEach((like, index)=>{
		like.addEventListener('click', () => {
			// get the last element from the girls
			hearts[index].classList.add('is-active');

			setTimeout(()=>{
				const lastGirl = girls.pop();
				lastGirl.classList.add('roll-out-right');
				liked.push(lastGirl);
				clickCounter++;
				if (clickCounter >= ab1) {
					createMatchScreen();
					modal.removeAttribute('hidden');
				}
				if (clickCounter === 9) {
					createMatchScreen();
					modal.removeAttribute('hidden');
				}
			},700);
		});
	
		dislikes[index].addEventListener('click', () => {
			const lastGirl = girls.pop();
			lastGirl.classList.add('roll-out-left');
			clickCounter++;
			if (clickCounter === 9) {
				createMatchScreen();
				modal.removeAttribute('hidden');
			}
		});

	})

});
